<template>
    <div>
        <Breadcrumbs main="Admin" submain="Portfolio" title="Affiliations" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Affiliation</h7>
                            </button>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="affiliation_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(position)="row">
                                            <div v-if="row.item.position" style="max-width: 450px;">
                                                <p>{{ row.item.position }}</p>
                                            </div>
                                        </template>
    
                                        <!-- <template #cell(logo)="row">
                                            <img :src="host+row.item.logo" alt="" style="width: 120px; height: 80px;">
                                        </template> -->
    
                                        <template #cell(title)="row">
                                            <div v-if="row.item.title">
                                                <p style="max-width: 450px;">{{ row.item.title }}</p>
                                            </div>
                                        </template>

                                        <template #cell(category)="row">
                                            <div v-if="row.item.category">
                                                <p>{{ row.item.category.name }}</p>
                                            </div>
                                        </template>
    
                                        <!-- <template #cell(link)="row">
                                            <div v-if="row.item.link">
                                                <a :href="row.item.link" target="_blank" class="link-style">{{ row.item.link.substring(0,40) }}</a>
                                            </div>
                                            <div v-else>
                                                N/A
                                            </div>
                                        </template> -->
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteAffiliation(data.item.id)" title="Delete"></feather>
                                                </div>
                                                <div @click="editAffiliation(data.item)">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Affiliation Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Affiliation" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Title</label>
                            <input class="form-control" type="text" placeholder="Enter affiliation title" v-model="affiliation.title">
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Position</label>
                            <input class="form-control" type="text" placeholder="Enter affiliation position" v-model="affiliation.position">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Category</label>
                            <select class="form-control" v-model="affiliation.category">
                                <option disabled value="">Select a category</option>
                                <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                                    {{ cat.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
               
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Link</label>
                            <input class="form-control" type="text" placeholder="Enter link URL" v-model="affiliation.link">
                        </div>
                    </div>
                    <!-- <div class="col-sm-6">
                        <div class="form-group">
                            <label>Serial</label>
                            <input class="form-control" type="number" placeholder="Enter serial" v-model="affiliation.serial" min="1">
                        </div>
                    </div> -->
                </div>
    
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Logo</label>
                            <div class="flex items-center">
                                <img v-if="show_logo" style="width: 120px; height: 80px;" :src="show_logo">
                                <input :class="affiliation.logo ? 'ml-4' : 'ml-0'" type="file" accept="logo/*" @change="uploadFile">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Affiliation Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Affiliation" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Title</label>
                            <input class="form-control" type="text" placeholder="Enter title" v-model="edit_affiliation.title">
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Position</label>
                            <input class="form-control" type="text" placeholder="Enter affiliation position" v-model="edit_affiliation.position">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Category</label>
                            <select class="form-control" v-model="edit_affiliation.category">
                                <option disabled value="">Select a category</option>
                                <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                                    {{ cat.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Link</label>
                            <input class="form-control" type="text" placeholder="Enter link URL" v-model="edit_affiliation.link">
                        </div>
                    </div>
                    <!-- <div class="col-sm-6">
                        <div class="form-group">
                            <label>Serial</label>
                            <input class="form-control" type="number" placeholder="Enter serial" v-model="edit_affiliation.serial" min="1">
                        </div>
                    </div> -->
                </div>
    
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Logo</label>
                            <div class="flex items-center">
                                <img v-if="show_logo" style="width: 120px; height: 80px;" :src="show_logo">
                                <input :class="edit_affiliation.logo ? 'ml-4' : 'ml-4'" type="file" accept="logo/*" @change="EdituploadFile">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Affiliation Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this affiliation?</div>
        </b-modal>
    </div>
</template>

<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import Datepicker from 'vuejs-datepicker';
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import moment from "moment";
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import js from '../../../auth/js';
    import loader from '../loader/loader.vue';
    
    export default {
        components: {
            Datepicker,
            loader
        },
    
        data() {
            return {
                editor: ClassicEditor,
                host: myHost.host,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                   
                    {
                        key: 'title',
                        label: 'Title',
                        sortable: true
                    },
                    {
                        key: 'position',
                        label: 'Position',
                        sortable: true
                    },
                    {
                        key: 'category',
                        label: 'Category',
                        sortable: true
                    },
                    
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],

                categories: [
                    { id: 1, value: 'universities', name: 'Affiliations with Universities' },
                    { id: 2, value: 'committee', name: 'Technical Committee Members' },
                    { id: 3, value: 'conferences', name: 'Organizing Conferences' },
                    { id: 4, value: 'membership', name: 'Membership in Professional Organizations' },
                ],
                
                affiliation: {
                    title: '',
                    position:'',
                    logo: '',
                    link: null,
                    category: '',
                    serial: 1
                },
    
                edit_affiliation: {
                    id: '',
                    title: '',
                    position:'',
                    logo: '',
                    link: null,
                    category: '',
                    serial: 1
                },
    
                show_logo: null,
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [5, 10, 15]
            };
        },
    
        computed: {
            ...mapState({
                affiliation_list: state => state.affiliation.affiliation,
                loading: state => state.affiliation.affiliationLoading,
                error: state => state.affiliation.affiliationError
            }),
    
            sortOptions() {
                // Create an options list from our fields
                return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },
    
        mounted() {
            this.$store.dispatch("affiliation/fetchAffiliation").then(() => {
                this.items = this.affiliation_list
                this.totalRows = this.items.length;
            })
        },
    
        methods: {
            uploadFile(e) {
                const logo = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(logo);
                reader.onload = e => {
                    this.show_logo = e.target.result
                    this.affiliation.logo = e.target.result;
                };
            },
    
            EdituploadFile(e) {
                const logo = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(logo);
                reader.onload = e => {
                    this.show_logo = e.target.result
                    this.edit_affiliation.logo = e.target.result;
                };
            },
    
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.affiliation.title = null
                this.affiliation.logo = null
                this.affiliation.position = null
                this.affiliation.serial = 1
                this.affiliation.link = null
                this.affiliation.category = null
                this.show_logo = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("affiliation/addAffiliation", {
                    affiliation: this.affiliation
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.affiliation.title = null
                        this.affiliation.logo = null
                        this.affiliation.position = null
                        this.affiliation.serial = 1
                        this.affiliation.link = null
                        this.affiliation.category = null
                        this.show_logo = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editAffiliation(detail) {
                this.edit_affiliation.id = detail.id ? detail.id : null
                this.edit_affiliation.title = detail.title ? detail.title : null
                this.edit_affiliation.position = detail.position ? detail.position : null
                this.edit_affiliation.link = detail.link ? detail.link : null
                this.show_logo = detail.logo ? this.host + detail.logo : null
                this.edit_affiliation.serial = detail.serial ? detail.serial : 1
                this.edit_affiliation.category = detail.category?detail.category.id : null
            },
    
            resetEditModal() {
                this.edit_affiliation.title = null
                this.edit_affiliation.logo = null
                this.edit_affiliation.position = null
                this.edit_affiliation.serial = 1
                this.edit_affiliation.link = null
                this.edit_affiliation.category = null
                this.show_logo = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.edit_affiliation.link = this.edit_affiliation.link ? this.edit_affiliation.link.trim() : null
                this.$store.dispatch("affiliation/updateAffiliation", {
                    id: this.edit_affiliation.id,
                    affiliation: this.edit_affiliation,
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.edit_affiliation.title = null
                        this.edit_affiliation.logo = null
                        this.edit_affiliation.position = null
                        this.edit_affiliation.serial = null
                        this.edit_affiliation.link = null
                        this.edit_affiliation.category = null
                        this.show_logo = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteAffiliation(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("affiliation/deleteAffiliation", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    